import { Heading } from "@stacklet/ui";

import { ControlPlusEnablement } from "../ControlPlusEnablement";

interface Props {
  /** Whether this deployment has a Jun0 endpoint configured. */
  isEnabled: boolean;
}

/**
 * Jun0 settings — an advertisement as much as a control panel. Jun0 ships with
 * Control+, and enabling it is a deployment change rather than a console one, so
 * the switch only ever reports the current state: it is always disabled, and a
 * deployment without Jun0 gets the pitch — what Control+ costs, and a way to ask
 * about it — where a deployment that already has it gets neither.
 */
export function Jun0Settings({ isEnabled }: Props) {
  return (
    <div className="flex flex-col gap-2xl">
      <Heading className="text-display-small" level={1}>
        Jun0
      </Heading>

      <div className="flex flex-col gap-md">
        <p className="text-body-medium text-text-secondary">
          Jun0 is Stacklet&apos;s AI-powered console assistant. Ask it questions
          in natural language to author and review Cloud Custodian policies, or
          query and visualize your cloud asset inventory data — no need to write
          GraphQL or SQL by hand.
        </p>

        <ControlPlusEnablement feature="Jun0" isEnabled={isEnabled} />
      </div>
    </div>
  );
}
